<template>
  <responsive-modal v-model="visible" title="Integrar Telegram">
    <div class="tool-modal-telegram">
      <a href="https://telegram.org/" target="_blank" class="integration-link">
        Conheça o Telegram
        <i class="ph ph-arrow-square-out" />
      </a>
      <div class="warning-card">
        <i class="ph ph-warning-circle fs-18" />
        <small>
          Para configurar sua integração, siga os seguintes passos: <br />
          - Usando o botão start, inicie a conversa com o ZeuspayBot, nosso robô
          do Telegram. <br />
          - Adicione o nosso robô como administrador a seus grupos ou canais no
          telegram com todas as permissões ativadas.
          <br />
          - Você receberá um código que será usado para concluir esse cadastro
          <strong>
            (código de configuração do telegram)
          </strong>
          .
        </small>
      </div>
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <snow-select
          :disabled="form.id != null"
          id="product-select"
          label="Produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <snow-input
        id="group-name"
        v-model="form.group_name"
        :rules="rules.group_name"
        label="Nome do grupo"
      />
      <snow-input
        id="config-code"
        v-model="form.telegram_config_code"
        :rules="rules.telegram_config_code"
        label="Código de configuração do telegram"
      />
      <snow-input
        id="chat-id"
        v-model="form.chat_id"
        label="ID do chat (opcional)"
      />
      <snow-input
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
      />
      <div class="snow-submit-buttons">
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
        <snow-button
          size="lg"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { clearObject, formFields } from "@/functions/helpers";
import { mapState } from "vuex";
import { required } from "@/functions/validation";
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields([
        "product_id",
        "group_name",
        "description",
        "telegram_config_code",
        "chat_id",
        "status"
      ]),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v
        };
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.product_id &&
        this.form.group_name &&
        this.form.telegram_config_code
      );
    },
    rules() {
      return {
        product_id: [required()],
        group_name: [required()],
        telegram_config_code: [required()]
      };
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      if (this.loading) return;

      this.loading = true;

      let data = {
        ...this.form
      };
      let action = "integration/postIntegration";

      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, clearObject(data))
        .then(this.onSuccess)
        .catch(e =>
          this.handleErrors(
            e,
            "TRANSLATE_FIELD_INTEGRATION_MAP",
            "Erro ao salvar integração"
          )
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-telegram {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
